import React from 'react';
import Aux from '../../../hoc/Aux';
import classes from './Input.css';

const input = (props) => {
    let inputElement = null;

    const inputClasses = [classes.InputElement];

    if(props.invalid && props.shouldValidate && props.touched) {
        inputClasses.push(classes.Invalid);
    }

    switch (props.elementType) {
        case ('input'):            
                inputElement = <input className={inputClasses.join(' ')} {...props.elementConfig} value={props.value} onChange={props.changed}/>;
            break;
        case ('textarea'):
            inputElement = <textarea className={inputClasses.join(' ')} {...props.elementConfig} value={props.value} onChange={props.changed}/>;
            break;
        case ('checkbox'):
            inputElement = <input type='checkbox' style={{float: 'left'}} className={inputClasses.join(' ')} {...props.elementConfig} checked={props.value}>{props.elementConfig.label}</input>;
            break;
        case ('select'):
            inputElement = <select className={inputClasses.join(' ')} {...props.elementConfig} value={props.value} onChange={props.changed}>
                {props.elementConfig.options.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.displayValue}
                    </option>
                ))}
            </select>
            break;
        default:
            inputElement = <input className={inputClasses.join(' ')} {...props.elementConfig} value={props.value} onChange={props.changed}/>;
    }

    const error = props.error ? <label style={{color: 'orange', paddingBottom: '20px'}} className={classes.Error}>{props.error}</label> : null;

    return (
        <div className={classes.Input}>
            {error} {error && props.elementConfig.type === 'checkbox' ? <Aux><br/><br/></Aux>: null}
            <label style={props.labelStyle} className={classes.Label}>{props.elementConfig.label}</label>
            {inputElement}
        </div>
    );
};

export default input;